module.exports = __webpack_public_path__ + "51aa9223a7892d61efa208afabaabe66.png";